import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import AntLocalization from '../../utils/AntLocalization';
import AntCondition from '../../utils/AntCondition';
import './index.scss';

// ─── Mock Data per chart type ────────────────────────────────────
var MOCK_DATA = {
    gauge: { value: 72.5, name: { vi: 'Tiến độ', en: 'Progress', fr: 'Avancement', es: 'Progreso', id: 'Progres', ja: '進捗', zh: '进度', ko: '진행률', hi: 'प्रगति', ar: 'التقدم' } },
    radar: [
        { name: { vi: 'Bán hàng', en: 'Sales', fr: 'Ventes', es: 'Ventas', id: 'Penjualan', ja: '販売', zh: '销售', ko: '판매', hi: 'बिक्री', ar: 'المبيعات' }, value: [85, 70, 90, 60, 75] },
        { name: { vi: 'Mục tiêu', en: 'Target', fr: 'Objectif', es: 'Objetivo', id: 'Target', ja: '目標', zh: '目标', ko: '목표', hi: 'लक्ष्य', ar: 'الهدف' }, value: [100, 100, 100, 100, 100] }
    ],
    heatmap: (function () {
        var data = [];
        var hours = ['9h', '10h', '11h', '12h', '13h', '14h', '15h', '16h', '17h'];
        var days = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'];
        for (var i = 0; i < days.length; i++) {
            for (var j = 0; j < hours.length; j++) {
                data.push([j, i, Math.round(Math.random() * 50 + 10)]);
            }
        }
        return data;
    })(),
    funnel: [
        { name: { vi: 'Tiếp cận', en: 'Reach', fr: 'Portée', es: 'Alcance', id: 'Jangkauan', ja: 'リーチ', zh: '触达', ko: '도달', hi: 'पहुँच', ar: 'الوصول' }, value: 1200 },
        { name: { vi: 'Quan tâm', en: 'Interest', fr: 'Intérêt', es: 'Interés', id: 'Minat', ja: '関心', zh: '兴趣', ko: '관심', hi: 'रुचि', ar: 'الاهتمام' }, value: 800 },
        { name: { vi: 'Tư vấn', en: 'Consult', fr: 'Conseil', es: 'Asesoría', id: 'Konsultasi', ja: '相談', zh: '咨询', ko: '상담', hi: 'परामर्श', ar: 'استشارة' }, value: 500 },
        { name: { vi: 'Báo giá', en: 'Quote', fr: 'Devis', es: 'Cotización', id: 'Penawaran', ja: '見積', zh: '报价', ko: '견적', hi: 'कोटेशन', ar: 'عرض سعر' }, value: 300 },
        { name: { vi: 'Chốt đơn', en: 'Close', fr: 'Conclusion', es: 'Cierre', id: 'Closing', ja: '成約', zh: '成交', ko: '성사', hi: 'सौदा पक्का', ar: 'إتمام' }, value: 120 }
    ],
    treemap: [
        {
            name: { vi: 'Điện tử', en: 'Electronics', fr: 'Électronique', es: 'Electrónica', id: 'Elektronik', ja: '家電', zh: '电子产品', ko: '전자제품', hi: 'इलेक्ट्रॉनिक्स', ar: 'إلكترونيات' }, value: 500,
            children: [
                { name: 'iPhone', value: 200 }, { name: 'iPad', value: 150 }, { name: 'MacBook', value: 150 }
            ]
        },
        {
            name: { vi: 'Thời trang', en: 'Fashion', fr: 'Mode', es: 'Moda', id: 'Fashion', ja: 'ファッション', zh: '时尚', ko: '패션', hi: 'फैशन', ar: 'الأزياء' }, value: 300,
            children: [
                { name: { vi: 'Áo', en: 'Shirts', fr: 'Hauts', es: 'Camisas', id: 'Baju', ja: 'シャツ', zh: '上衣', ko: '상의', hi: 'शर्ट', ar: 'قمصان' }, value: 120 }, { name: { vi: 'Quần', en: 'Pants', fr: 'Pantalon', es: 'Pantalón', id: 'Celana', ja: 'パンツ', zh: '裤子', ko: '바지', hi: 'पैंट', ar: 'بناطيل' }, value: 100 }, { name: { vi: 'Giày', en: 'Shoes', fr: 'Souliers', es: 'Zapatos', id: 'Sepatu', ja: '靴', zh: '鞋子', ko: '신발', hi: 'जूते', ar: 'أحذية' }, value: 80 }
            ]
        },
        { name: { vi: 'Thực phẩm', en: 'Food', fr: 'Alimentaire', es: 'Alimentos', id: 'Makanan', ja: '食品', zh: '食品', ko: '식품', hi: 'खाद्य', ar: 'أغذية' }, value: 250 }
    ],
    scatter: (function () {
        var data = [];
        for (var i = 0; i < 40; i++) {
            data.push([Math.round(Math.random() * 100), Math.round(Math.random() * 100)]);
        }
        return data;
    })(),
    sankey: {
        nodes: [
            { name: { vi: 'Doanh thu', en: 'Revenue', fr: 'Revenus', es: 'Ingresos', id: 'Pendapatan', ja: '売上', zh: '营收', ko: '매출', hi: 'राजस्व', ar: 'الإيرادات' } },
            { name: { vi: 'Bán hàng', en: 'Sales', fr: 'Ventes', es: 'Ventas', id: 'Penjualan', ja: '販売', zh: '销售', ko: '판매', hi: 'बिक्री', ar: 'المبيعات' } },
            { name: { vi: 'Dịch vụ', en: 'Services', fr: 'Services', es: 'Servicios', id: 'Layanan', ja: 'サービス', zh: '服务', ko: '서비스', hi: 'सेवाएँ', ar: 'الخدمات' } },
            { name: { vi: 'Giá vốn', en: 'COGS', id: 'HPP', ja: '売上原価', ko: '매출원가', fr: 'Coût', es: 'Costo', zh: '成本', hi: 'लागत', ar: 'التكلفة' } },
            { name: { vi: 'Lãi gộp', en: 'Gross Profit', fr: 'Bénéfice brut', es: 'Margen bruto', id: 'Laba kotor', ja: '粗利益', zh: '毛利', ko: '총 이익', hi: 'सकल लाभ', ar: 'الربح الإجمالي' } },
            { name: { vi: 'Chi phí', en: 'Expenses', fr: 'Dépenses', es: 'Gastos', id: 'Biaya', ja: '経費', zh: '费用', ko: '비용', hi: 'व्यय', ar: 'المصروفات' } },
            { name: { vi: 'Lãi ròng', en: 'Net Profit', fr: 'Bénéfice net', es: 'Utilidad neta', id: 'Laba bersih', ja: '純利益', zh: '净利润', ko: '순이익', hi: 'शुद्ध लाभ', ar: 'صافي الربح' } }
        ],
        links: [
            { source: 0, target: 1, value: 800 },
            { source: 0, target: 2, value: 200 },
            { source: 1, target: 3, value: 500 },
            { source: 1, target: 4, value: 300 },
            { source: 2, target: 4, value: 200 },
            { source: 4, target: 5, value: 200 },
            { source: 4, target: 6, value: 300 }
        ]
    }
};

var MOCK_INDICATORS = {
    radar: [
        { name: { vi: 'Doanh thu', en: 'Revenue', fr: 'Revenus', es: 'Ingresos', id: 'Pendapatan', ja: '売上', zh: '营收', ko: '매출', hi: 'राजस्व', ar: 'الإيرادات' }, max: 100 },
        { name: { vi: 'Lợi nhuận', en: 'Profit', fr: 'Profit', es: 'Ganancia', id: 'Laba', ja: '利益', zh: '利润', ko: '이익', hi: 'लाभ', ar: 'ربح' }, max: 100 },
        { name: { vi: 'Khách hàng', en: 'Customers', fr: 'Clients', es: 'Clientes', id: 'Pelanggan', ja: '顧客', zh: '客户', ko: '고객', hi: 'ग्राहक', ar: 'العملاء' }, max: 100 },
        { name: { vi: 'Sản phẩm', en: 'Products', fr: 'Produits', es: 'Productos', id: 'Produk', ja: '商品', zh: '商品', ko: '상품', hi: 'उत्पाद', ar: 'المنتجات' }, max: 100 },
        { name: { vi: 'NV', en: 'Staff', fr: 'Équipe', es: 'Personal', id: 'Staf', ja: '人員', zh: '员工', ko: '직원', hi: 'स्टाफ़', ar: 'موظفون' }, max: 100 }
    ]
};

var MOCK_AXIS = {
    heatmap: {
        xAxis: ['9h', '10h', '11h', '12h', '13h', '14h', '15h', '16h', '17h'],
        yAxis: ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN']
    }
};

let echarts = null;
let echartsAvailable = false;

try {
    echarts = require('echarts/core');
    const { GaugeChart, RadarChart, HeatmapChart, FunnelChart, TreemapChart, ScatterChart, SankeyChart } = require('echarts/charts');
    const {
        TitleComponent, TooltipComponent, LegendComponent,
        VisualMapComponent, GridComponent, RadarComponent
    } = require('echarts/components');
    const { CanvasRenderer } = require('echarts/renderers');

    echarts.use([
        GaugeChart, RadarChart, HeatmapChart, FunnelChart, TreemapChart, ScatterChart, SankeyChart,
        TitleComponent, TooltipComponent, LegendComponent,
        VisualMapComponent, GridComponent, RadarComponent,
        CanvasRenderer
    ]);
    echartsAvailable = true;
} catch (e) {
    echartsAvailable = false;
}

const DEFAULT_COLORS = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'];

function resolveTitle(title) {
    if (!title) return undefined;
    if (typeof title === 'string') return title;
    return AntLocalization.translateText(title);
}

const PRESETS = {
    gauge: (data, props) => {
        const val = typeof data === 'number' ? data : (data?.value ?? 0);
        const name = data?.name ? resolveTitle(data.name) : '';
        return {
            series: [{
                type: 'gauge',
                data: [{ value: val, name }],
                detail: { formatter: '{value}%' },
                ...(props.color ? { itemStyle: { color: Array.isArray(props.color) ? props.color[0] : props.color } } : {})
            }]
        };
    },

    radar: (data, props) => {
        const indicators = (props.indicators || []).map((ind) => {
            if (typeof ind === 'string') return { name: ind };
            return { name: resolveTitle(ind.name) || ind.name, max: ind.max };
        });
        const seriesData = Array.isArray(data) ? data.map((d) => ({
            value: d.value || d,
            name: resolveTitle(d.name) || d.name
        })) : [{ value: data }];
        return {
            radar: { indicator: indicators },
            series: [{ type: 'radar', data: seriesData }]
        };
    },

    heatmap: (data, props) => {
        const xData = props.xAxis || [];
        const yData = props.yAxis || [];
        let maxVal = 0;
        const seriesData = (Array.isArray(data) ? data : []).map((item) => {
            const val = Array.isArray(item) ? item[2] : item.value;
            if (val > maxVal) maxVal = val;
            return item;
        });
        return {
            xAxis: { type: 'category', data: xData },
            yAxis: { type: 'category', data: yData },
            visualMap: { min: 0, max: maxVal || 1, calculable: true, orient: 'horizontal', left: 'center', bottom: 0 },
            series: [{ type: 'heatmap', data: seriesData, label: { show: true } }]
        };
    },

    funnel: (data, props) => {
        const seriesData = (Array.isArray(data) ? data : []).map((d) => ({
            value: d.value ?? d,
            name: resolveTitle(d.name) || d.name || ''
        }));
        return {
            legend: { data: seriesData.map((d) => d.name) },
            series: [{ type: 'funnel', data: seriesData, label: { show: true, position: 'inside' } }]
        };
    },

    treemap: (data) => {
        const seriesData = (Array.isArray(data) ? data : []).map((d) => ({
            value: d.value ?? d,
            name: resolveTitle(d.name) || d.name || '',
            children: d.children
        }));
        return {
            series: [{ type: 'treemap', data: seriesData }]
        };
    },

    scatter: (data, props) => {
        const seriesData = Array.isArray(data) ? data : [];
        return {
            xAxis: { type: 'value' },
            yAxis: { type: 'value' },
            series: [{ type: 'scatter', data: seriesData, symbolSize: 10 }]
        };
    },

    sankey: (data) => {
        const nodes = (data && data.nodes) ? data.nodes.map((n) => ({
            name: resolveTitle(n.name) || n.name || ''
        })) : [];
        const links = (data && data.links) ? data.links.map((l) => ({
            source: typeof l.source === 'number' ? (nodes[l.source] ? nodes[l.source].name : l.source) : (resolveTitle(l.source) || l.source),
            target: typeof l.target === 'number' ? (nodes[l.target] ? nodes[l.target].name : l.target) : (resolveTitle(l.target) || l.target),
            value: l.value
        })) : [];
        return {
            series: [{ type: 'sankey', data: nodes, links: links, emphasis: { focus: 'adjacency' }, lineStyle: { color: 'gradient', curveness: 0.5 } }]
        };
    }
};

export default function AntEChart(props) {
    const {
        type, data: dataProp, option, height = 300, width = '100%',
        title, color, onEvents, loading, theme = 'light',
        // Mock mode & API
        mockMode = false,
        API, apiMethod, apiParams,
        // Visibility condition
        visible, session,
        // Auto-refresh
        refreshInterval
    } = props;

    const [apiData, setApiData] = useState(null);
    const refreshRef = useRef(null);

    // ─── Visibility check ───────────────────────────────────────
    if (visible && session) {
        var isVis = AntCondition.checkAll({}, visible, session);
        if (!isVis) return null;
    }

    // ─── Resolve data: mockMode → API → prop ────────────────────
    const data = useMemo(() => {
        if (mockMode && type && MOCK_DATA[type]) return MOCK_DATA[type];
        if (apiData !== null) return apiData;
        return dataProp;
    }, [mockMode, type, apiData, dataProp]);

    // ─── Load from API ──────────────────────────────────────────
    const loadApiData = useCallback(async () => {
        if (!API || !apiMethod || mockMode) return;
        try {
            var result = await API[apiMethod](apiParams || {});
            if (result && result.data) setApiData(result.data);
            else if (result) setApiData(result);
        } catch (e) { /* silent */ }
    }, [API, apiMethod, apiParams, mockMode]);

    useEffect(() => {
        loadApiData();
    }, [loadApiData]);

    useEffect(() => {
        if (refreshInterval && refreshInterval > 0 && !mockMode && API) {
            refreshRef.current = setInterval(loadApiData, refreshInterval * 1000);
            return () => clearInterval(refreshRef.current);
        }
    }, [refreshInterval, loadApiData, mockMode, API]);

    const chartRef = useRef(null);
    const instanceRef = useRef(null);

    const chartOption = useMemo(() => {
        if (option) return option;
        if (!type || !PRESETS[type]) return null;

        // When mockMode, inject mock indicators/axis if not provided
        var resolvedProps = { ...props };
        if (mockMode) {
            if (type === 'radar' && !resolvedProps.indicators && MOCK_INDICATORS[type]) {
                resolvedProps.indicators = MOCK_INDICATORS[type];
            }
            if (type === 'heatmap' && !resolvedProps.xAxis && MOCK_AXIS[type]) {
                resolvedProps.xAxis = MOCK_AXIS[type].xAxis;
                resolvedProps.yAxis = MOCK_AXIS[type].yAxis;
            }
        }

        const preset = PRESETS[type](data, resolvedProps);
        const titleText = resolveTitle(title);

        return {
            ...(titleText ? { title: { text: titleText } } : {}),
            tooltip: { trigger: type === 'scatter' ? 'item' : (type === 'heatmap' ? 'item' : 'item') },
            ...(color ? { color: Array.isArray(color) ? color : [color] } : { color: DEFAULT_COLORS }),
            ...preset
        };
    }, [type, data, option, title, color, props.indicators, props.xAxis, props.yAxis, mockMode]);

    useEffect(() => {
        if (!echartsAvailable || !chartRef.current) return;

        if (instanceRef.current) {
            instanceRef.current.dispose();
        }

        const chart = echarts.init(chartRef.current, theme === 'dark' ? 'dark' : undefined);
        instanceRef.current = chart;

        if (chartOption) {
            chart.setOption(chartOption, true);
        }

        if (onEvents && typeof onEvents === 'object') {
            Object.keys(onEvents).forEach((eventName) => {
                if (typeof onEvents[eventName] === 'function') {
                    chart.on(eventName, onEvents[eventName]);
                }
            });
        }

        let observer = null;
        if (typeof ResizeObserver !== 'undefined') {
            observer = new ResizeObserver(() => {
                if (instanceRef.current) {
                    instanceRef.current.resize();
                }
            });
            observer.observe(chartRef.current);
        }

        return () => {
            if (observer) {
                observer.disconnect();
            }
            if (instanceRef.current) {
                instanceRef.current.dispose();
                instanceRef.current = null;
            }
        };
    }, [chartOption, theme]);

    useEffect(() => {
        if (!instanceRef.current) return;
        if (loading) {
            instanceRef.current.showLoading();
        } else {
            instanceRef.current.hideLoading();
        }
    }, [loading]);

    if (!echartsAvailable) {
        return (
            <div className="ant-echart" style={{ width, height }}>
                <div className="ant-echart-placeholder">
                    ECharts not installed. Run: <code>npm install echarts</code>
                </div>
            </div>
        );
    }

    return (
        <div className="ant-echart" style={{ width, height: typeof height === 'number' ? height + 'px' : height }}>
            <div ref={chartRef} style={{ width: '100%', height: '100%' }} />
            {loading && <div className="ant-echart-loading"><div className="ant-echart-spinner" /></div>}
        </div>
    );
}
